import * as z from "zod";
import Papa from "papaparse";
import { Logger } from "helpers/LogHelper";

export const validatorSchema = z.object({
  file: z
    .custom<File>()

    //Checar se o arquivo é vazio
    .refine(
      (file) => {
        return !!file;
      },
      {
        message: "upload-modal.validation.empty-file",
      },
    )

    //Checar se o arquivo é do tipo CSV
    .refine(
      (file) => {
        return file.type === "text/csv";
      },
      {
        message: "upload-modal.validation.wrong-file",
      },
    )

    //Checar se o arquivo tem as colunas: "workerID", "documentType", "documentNumber", "documentSecurityNumber"
    .refine(
      async (file) => {
        return new Promise((resolve, reject) => {
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            preview: 1,
            complete: (results) => {
              //check if the headers are: "workerID", "documentType", "documentNumber", "documentSecurityNumber"
              const headers = results.meta.fields;
              if (!!headers && headers.length !== 4) {
                resolve(false);
              }
              if (
                !(
                  headers?.includes("workerID") &&
                  headers?.includes("documentType") &&
                  headers?.includes("documentNumber") &&
                  headers?.includes("documentSecurityNumber")
                )
              ) {
                resolve(false);
              }

              resolve(true);
            },
            error: (error) => {
              Logger("error", "Erro ao ler o arquivo: ", error, "validator.ts");
              reject(false);
            },
          });
        });
      },
      {
        message: "upload-modal.validation.wrong-headers",
      },
    )

    //Checar se o arquivo tem conteúdo
    .refine(
      async (file) => {
        return new Promise((resolve, reject) => {
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            preview: 1,
            complete: (results) => {
              if (results.data.length === 0) {
                resolve(false);
              }

              resolve(true);
            },
            error: (error) => {
              Logger("error", "Erro ao ler o arquivo: ", error, "validator.ts");
              reject(false);
            },
          });
        });
      },
      {
        message: "upload-modal.validation.no-content",
      },
    )

    //transformar csv em objeto
    .transform(async (file) => {
      if (!file) {
        return [];
      }
      return new Promise((resolve) => {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            resolve(results.data);
          },
          error: (error) => {
            Logger("error", "Erro ao ler o arquivo: ", error, "validator.ts");
            resolve([]);
          },
        });
      });
    }),
});
